<template>
  <v-dialog width="100%" max-width="360px" v-model="dialog_visible">
    <template #activator="{ on }">
      <v-btn icon small class="ml-2 mr-1" v-on="on">
        <v-icon>mdi-calendar-month</v-icon>
      </v-btn>
    </template>

    <div class="white rounded-lg pa-3">
      <h2>Narrow your Search</h2>

      <v-divider />

      <div class="d-flex align-center mt-3">
        <div style="white-space: nowrap" class="mr-4">Time Period:</div>
        <v-select :items="items" 
          :item-text="i => i.label"
          :item-value="i => i.value"
          outlined dense hide-details
          class="flex-shrink-1"
          v-model="selected"
        />
      </div>

      <v-divider class="my-3" />

      <div class="d-flex justify-center">
        <v-btn @click="dialog_visible = false"> Cancel </v-btn>
        <v-btn class="ml-2" color="primary" @click="okClick"> Ok </v-btn>
      </div>

    </div>
  </v-dialog>
</template>

<script>
export default {
  props: ['value'],

  data() {
    return {
      selected: this.value,
      dialog_visible: false,

      items: [
        { label: 'today', value: 1 },
        { label: 'last 7 days', value: 7 },
        { label: 'last 30 days', value: 30 },
        { label: 'last 90 days', value: 90 },
      ],
    }
  },

  methods: {
    okClick() {
      this.$emit('input', this.selected)
      this.dialog_visible = false
    }
  },
}
</script>